import { darken } from '@mui/material/styles';

export function sectionBgColor(color: string | undefined, isDark: boolean): string | undefined {
    if (!color) {
        return color;
    }
    return isDark ? darken(color, 0.5) : color;
}

export function invertColor(hex: string): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
}
